var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Error"},[_c('div',{staticClass:"ErrorBox"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.picUrl+'qunaer/common/404.png',"alt":"404资源访问不到"}}),_c('p',{staticClass:"text"},[_vm._v("找不到页面了")])])])}
var staticRenderFns = []

export { render, staticRenderFns }